// i18n area 'apps' — locale no-NO (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.no-NO.meta.json.
import type { enUS } from './apps'

export const noNO: typeof enUS = {
  apps: {
    title: 'Apper',
    create: 'Opprett app',
    createTitle: 'Opprett app',
    editTitle: 'Rediger app',
    name: 'Navn',
    nameHint: 'DNS-1123, unikt i scopen — uforanderlig etter opprettelsen.',
    node: 'Node',
    nodeHint: 'Medlemsnoden som betjener den — eksplisitt placement (scheduleren kommer senere).',
    image: 'Bilde',
    editImageHint: 'En ny referanse løses opp på nytt via registeret — pin-/rollback-gesten.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digesten flytter seg bare på kommando.',
    policyTrackingHint: 'Automatisk rolling når en refresh flytter branchen.',
    archMovePolicy: 'Cross-arch-flytting',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Hva som skjer hvis appen flyttes til en node med en annen arkitektur: refuse avviser flyttingen, reresolve løser lockfilen på nytt fra branchen på den nye arch-en — innholdet endres, og svaret navngir digest-endringen.',
    network: 'Nettverk',
    networkHint: 'Utagget L3-tilkobling: et logisk fabric-nett (anbefalt — gateway/DNS fra dets eneste kilde), et overlay, eller en naken host-bridge (frarådes).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'host-bridge:',
    ipAssignment: 'IP-tildeling',
    ipStatic: 'Statisk',
    ipAuto: 'Automatisk (IPAM)',
    ipAssignmentHint_static: 'Adressen gir du, nå.',
    ipAssignmentHint_auto: 'IPAM-en velger en ledig adresse fra nettets TVirt-reserverte ranger.',
    bridgeDiscouraged: 'Naken host-bridge — FRARÅDES: TVirt vet ingenting om adresseringen dens, så gateway og DNS må gis for hånd. Den anbefalte veien er et logisk fabric-nett.',
    ip: 'IP',
    ipHint: 'Statisk IPv4 innenfor tilkoblingens subnett.',
    ipCidrHint: 'I CIDR-form på en naken bridge (f.eks. 192.168.1.10/24) — det finnes ingenting å avlede prefikset fra.',
    gateway: 'Gateway',
    gatewayManualHint: 'Manuell — en naken bridge avleder ingenting.',
    dnsServers: 'DNS-servere',
    dnsManualHint: 'Manuelle, kommaseparert — minst én.',
    rootKind: 'Root',
    rootEphemeral: 'efemer',
    rootPersistent: 'persistent',
    rootEphemeralHint: 'Gjenskapes fra bildet ved hver gjenskapelse; lever på klusterets efemere storage.',
    rootEphemeralHintNamed: 'Gjenskapes fra bildet ved hver gjenskapelse; lever på klusterets efemere storage ({name}).',
    rootPersistentHint: 'Overlever omstartene; lever på storagen du velger.',
    rootStorage: 'Root-storage',
    editRootStorageHint: 'Rooten re-renderes på den nye poolen — eksisterende data flytter seg IKKE av seg selv.',
    volumes: 'Volumer',
    volumeAdd: 'Legg til volum',
    volumeName: 'Navn',
    volumeMountPath: 'Mount-sti',
    volumeKind: 'Type',
    volumeStorage: 'Storage',
    devices: 'Enheter',
    deviceClassHint: 'Man ber om en KLASSE (en gpu-device- eller usb-device-tagg), aldri en bestemt enhet: den oppgitte noden må ha en som er merket for Apps. Flere Apps kan bruke samme enhet — en container deler den, den tar den ikke fra verten.',
    deviceSlot: 'Slot',
    deviceTag: 'Tagg',
    deviceValue: 'Klasse',
    deviceUnresolved: 'ingenting løses akkurat nå',
    noDeviceTags: 'Ingen tagg av typen gpu-device eller usb-device ennå: opprett en og tildel den til enhetene som er merket for Apps.',
    env: 'Miljø',
    envHint: 'Én NØKKEL=verdi per linje.',
    secretEnvTitle: 'Hemmelige variabler',
    secretEnvNotice: 'En hemmelig verdi kommer aldri tilbake fra API-et: ingen leser den igjen, ikke engang den som skrev den. I checkpointet reiser den forseglet med masterpassen, så en gjenoppretting uten masterpassen ber om at den skrives inn på nytt.',
    secretEnvPromote: 'Gjør en av variablene skrevet ovenfor hemmelig:',
    secretEnvAdd: 'Legg til hemmelig variabel',
    secretEnvName: 'Navn',
    secretEnvValue: 'Verdi',
    secretEnvKept: 'bevart — la stå tomt for å la den være uendret',
    secretEnvWithdrawWarning: 'For å slutte å behandle som hemmelig en variabel som allerede er det, skriv en ny verdi til den: bare å fjerne markeringen ville vært en måte å LESE det som aldri forlater storet. Å fjerne variabelen sletter den derimot.',
    secretEnvChip: 'hemmelig',
    startNow: 'Start med en gang (ellers fødes appen stoppet)',
    deletePersistentIntro: 'Denne appen har persistente data — velg hva som skal skje med dem:',
    deleteKeepData: 'Behold dataene (directoryene blir stående på storagene sine, foreldreløse)',
    deletePurgeData: 'Slett dataene også',
    phase: 'Fase',
    phase_running: 'Kjører',
    phase_stopped: 'Stoppet',
    phase_error: 'Feil',
    phase_unknown: 'Ukjent',
    desiredState: 'Ønsket',
    wantedRunning: 'kjørende',
    wantedStopped: 'stoppet',
    start: 'Start',
    stop: 'Stopp',
    restart: 'Start på nytt',
    refreshImage: 'Oppdater bildet (adopter den nye @current)',
    logs: 'Logg',
    logsTitle: 'Logg',
    logsEmpty: 'Ingen output fanget.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Appen kjører ikke — et shell trenger en levende container. Loggene kan leses i enhver tilstand.',
    shellConnect: 'Koble til',
    shellDisconnect: 'Koble fra',
    shellExited: 'Økten ble avsluttet med exit-kode {code}.',
    shellEndedWithoutStatus: 'Økten ble avsluttet uten exit-status: {reason}',
    shellRevoked: 'Øktens ticket er ikke lenger gyldig — den utløp, eller innloggingen som åpnet den ble tilbakekalt.',
    shellHint: 'Klikk i det svarte feltet og skriv: tastene går til containeren. Ctrl+C og piltastene virker; exit lukker shellet.',
    shellStatus: {
      connecting: 'Kobler til…',
      connected: 'Tilkoblet',
      ended: 'Avsluttet'
    },
    deleteRunningError: '{name} er ønsket kjørende — stopp den først.',
    tabs: {
      general: 'Generelt',
      image: 'Bilde',
      network: 'Nettverk',
      storage: 'Storage',
      devices: 'Enheter',
      observed: 'Observert'
    },
    attachment: 'Tilkobling',
    runningDigest: 'Kjørende digest',
    lastError: 'Siste feil',
    reportObservedAt: 'Siste rapport fra workeren',
    desiredStateLock: 'Styres av handlingene Start/Stopp — aldri en direkte endring.',
    ipEditDisabledHint: 'Kan bare endres med statisk tildeling.',
    derivedFromNetworkHint: 'Avledet av nettets eneste kilde — manuell bare på naken bridge med statisk IP.',
    ephemeralUnset: 'ikke konfigurert',
    ephemeralMissing: 'Appenes efemere storage er ikke konfigurert — å opprette en app med efemere deler (root eller volumer) avvises til du setter den.',
    ephemeralCurrent: 'Appenes efemere storage: {name}',
    ephemeralMissingCreate: 'Denne appen har efemere deler, men Appenes efemere storage er ikke satt — opprettelsen blir avvist. Sett den først fra banneret på App-siden.',
    setEphemeral: 'Sett efemer storage',
    changeEphemeral: 'Bytt efemer storage',
    setEphemeralTitle: 'Sett Appenes efemere storage',
    changeEphemeralTitle: 'Bytt Appenes efemere storage',
    ephemeralStorageHint: 'Kluster-DEFAULT: den dir-aktige poolen der rootene og de efemere volumene til hver app lever, med mindre appen deklarerer en override. Et bytte er ikke hot og starter ingenting på nytt: det gjelder fra neste start av hver app — de efemere dataene flytter seg ikke.',
    ephemeralPool: 'Storage-pool',
    ephemeralOverride: 'Efemer storage (per-app-override)',
    ephemeralOverrideInherit: 'Arver klusterets default',
    ephemeralOverrideInheritNamed: 'Arver klusterets default ({name})',
    ephemeralOverrideHint: 'Per-app-pool for root og efemere volumer — la stå tomt for å arve klusterets default. Å bytte den er ikke hot og starter ingenting på nytt: det gjelder fra neste start (efemere data gjenfødt tomme på den nye poolen) og krever tillatelsen app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Alle branches',
    imageBranchHint: 'Begrenser imagene til dem denne branchen navngir; uten branch ser du alle imagene i repositoryet.',
    imageDigestHint: 'Innholdet: velges fra digest-tabellen, som bærer opphavet og arkitekturen. Samme branch tilbyr ett per arkitektur, og de kan ikke byttes om.',
    imageLockfile: 'Oppløst referanse',
    imageNoImages: 'Ingen image i cachen for dette repositoryet — hent ett fra OCI-images.',
    imageHeadNotCached: 'ikke i cachen — hentes ved oppstart',
    imageNoRegistries: 'Ingen repository registrert: registrer ett for å kunne velge et image.',
    imageChosenHint: 'Imaget velges i kaskaden i redigeringsdialogen: referansen skrives aldri for hånd.',
    registerRepositoryHint: 'Registrering laster ikke ned noe: den gjør et repository observerbart, slik at imaget kan velges uten å forlate denne dialogen.',
    registerRepositoryBranchHint: 'Valgfritt: den første branchen som skal observeres (f.eks. latest).',
    registerRepositoryElsewhere: 'Repositoryet du leter etter er ikke registrert: registreringen skjer i seksjonen OCI-images, av noen med tillatelsen.'
  },
  cts: {
    createAction: 'Opprett CT',
    createTitle: 'Opprett en container fra en template',
    createError: 'Containeren ble ikke opprettet',
    template: 'CT-template',
    noTemplates: 'Ingen CT-template — importer en fra CT-templater',
    resources: 'Ressurser',
    node: 'Node',
    phase: {
      defined: 'Aldri slått på',
      materializing: 'Materialiseres',
      ready: 'Klar',
      starting: 'Starter',
      running: 'Kjører',
      stopping: 'Stopper',
      stopped: 'Stoppet',
      deleting: 'Slettes',
      error: 'Feil'
    },
    actions: {
      start: 'Start',
      stop: 'Stopp',
      restart: 'Start på nytt',
      markTemplate: 'Forfrem til CT-template',
      error: 'Handlingen ble avvist'
    },
    markTemplate: {
      confirmTitle: "Forfremme '{name}' til CT-template?",
      confirmBody: 'Containeren forlater denne listen og går over til CT-templatene, straks klar til å generere nye CT-er. Metadataene forblir redigerbare, og du kan gjøre den om til CT igjen når som helst.',
      confirm: 'Forfrem',
      moved: "'{name}' er nå en CT-template — du finner den i CT-templater."
    },
    stopCause: {
      api: 'Stoppet av TVirt',
      'ct-exit': 'Containeren avsluttet selv',
      'host-reboot': 'Døde med nodens omstart',
      'start-failed': 'Starten mislyktes — taskens feil sier hva som mangler og hvordan det fikses'
    },

    console: 'Konsoll',
    consoleUnavailable: 'Containeren kjører ikke — en konsoll trenger en levende container. Loggen derimot kan leses i hvilken som helst tilstand.',
    consoleNoTemplate: 'En template kjører aldri og har derfor ingen konsoll: opprett en CT fra den og åpne konsollen der.',
    consoleConnect: 'Koble til',
    consoleDisconnect: 'Koble fra',
    consoleReconnect: 'Koble til igjen',
    consoleTakenBy: 'En annen operatør har tatt denne konsollen ({user}). Én konsoll per container: kobler du til igjen, tar du den tilbake.',
    consoleHint: 'Klikk på det svarte feltet og skriv: tastene når fram til containeren. Ctrl+C og piltastene virker.',
    consoleEndpointDown: 'Konsollens tilgangspunkt kan ikke åpnes på noden som betjener containeren: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Containeren kjører ikke — et shell trenger en levende container. Loggene dens kan leses i enhver tilstand.',
    shellNoTemplate: 'En template kjører aldri, så den har ikke noe shell: opprett en CT fra den og åpne dens.',
    shellConnect: 'Koble til',
    shellDisconnect: 'Koble fra',
    shellExited: 'Økten ble avsluttet med exit-kode {code}.',
    shellEndedWithoutStatus: 'Økten ble avsluttet uten exit-status: {reason}',
    shellRevoked: 'Øktens ticket er ikke lenger gyldig — den utløp, eller innloggingen som åpnet den ble tilbakekalt.',
    shellHint: 'Klikk i det svarte feltet og skriv: tastene går til containeren. Ctrl+C og piltastene virker; exit lukker shellet.',
    shellStatus: {
      connecting: 'Kobler til…',
      connected: 'Tilkoblet',
      ended: 'Avsluttet'
    },
    rootPassword: 'Root-passord',
    rootPasswordHint: 'Skrives én gang inn i det kopierte rootfs (som hash, vises aldri igjen). Distribusjonenes images har ikke noe root-passord: uten det er shellet den eneste veien inn.',
    sshKeys: 'Offentlige SSH-nøkler for root',
    sshKeysHint: 'Én offentlig OpenSSH-nøkkel per linje, i root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Kobler til…',
      connected: 'Tilkoblet',
      reconnecting: 'Kobler til igjen…'
    },
    logs: 'Logg',
    logsTitle: 'Logg',
    logsEmpty: 'Ingen output fanget.',
    logsSource: 'Hvilken logg',
    logsSourceConsole: 'Containerens init-konsoll — hvorfor tjenesten inni ikke startet',
    logsSourceSupervisor: 'liblxc-supervisoren — hvorfor containeren aldri kom så langt som til å kjøre',
    logsNeverStarted: 'Den har aldri blitt startet, så det er ennå ingenting logget — start den, og loggen er der selv om starten mislykkes.',
    logsNoTemplate: 'En template kjører aldri og har derfor aldri logget noe.',
    logsError: 'Loggen ble ikke fanget',

    tabs: {
      general: 'Generelt',
      hardware: 'Hardware',
      network: 'Nettverk',
      provenance: 'Opphav'
    },
    templateFlag: 'CT-template',
    templateLock: 'Endres bare med handlingene Forfrem / Gjør om til CT — aldri en direkte endring.',
    sourceLock: 'Opphav, registrert ved fødselen — aldri omskrevet; en død kilde etterlater den nakne referansen.',
    storageLock: 'Fastsatt ved opprettelsen — flytting av rootfs-en er en fremtidig runde.',
    startedAt: 'Startet',
    lastStop: 'Siste stopp',
    editNicsTitle: 'Rediger nettene',
    nicDisconnected: 'frakoblet'
  },
  ctTemplates: {
    title: 'CT-templater',
    importAction: 'Importer fra katalog',
    importTitle: 'Importer CT-template fra katalogen',
    importSubmit: 'Importer',
    importError: 'Importen ble avvist',
    importHint: 'Å materialisere kopierer rootfs-en til den valgte storagen — katalogfilen forblir intakt. For å legge til nye filer, last dem først opp i en katalog.',
    sourceFile: 'CT-template-fil',
    sourceFileHint: 'ct-rootfs-filene i den valgte katalogen, bare de klare',
    noFiles: 'Ingen klar ct-rootfs-fil i denne katalogen — last opp en fra katalogsiden',
    source: 'Kildefil',
    rootfsStorage: 'Rootfs-storage',
    rootfsStorageHint: "Der det utpakkede rootfs-treet lever — en storage med filsystem og nok ledig plass til den utpakkede størrelsen pluss omtrent 1 GiB margin (ellers mislykkes importen).",
    resources: 'Ressurser',
    cores: 'vCPU',
    memoryMiB: 'Minne (MiB)',
    cpuLimit: 'CPU-grense',
    cpuLimitHint: 'Ekvivalenter av host-kjerner (f.eks. 1.5); tomt = uten tak',
    cpuUncapped: 'uten tak',
    cpuWeight: 'CPU-vekt',
    hostname: 'Hostname',
    hostnameHint: 'Tomt = CT-ens navn',
    nameservers: 'DNS-nameservere',
    dnsHint: 'Kommaseparert; tomt = arver hostens',
    searchDomains: 'DNS-søkedomener',
    dnsInherited: 'Arvet fra hosten',
    networks: 'Nett',
    nicSlot: 'NIC-slot',
    phase: {
      materializing: 'Materialiseres',
      ready: 'Klar',
      deleting: 'Slettes',
      error: 'Feil'
    },
    exportAction: 'Eksporter til katalogen',
    exportTitle: 'Eksporter til katalogen',
    exportSubmit: 'Eksporter',
    exportError: 'Eksporten ble avvist',
    exportHint: 'Pakker den materialiserte rootfs-en inn i en NY ct-rootfs-fil i den valgte katalogen — templaten forblir intakt.',
    exportName: 'Filnavn',
    exportNameHint: 'Tomt = <template>-export-<n>',
    markCt: {
      action: 'Gjør om til CT',
      confirmTitle: "Gjøre '{name}' om til CT igjen?",
      confirmBody: 'Templaten forlater denne listen og går tilbake til CT-listen, startbar igjen. Før du forfremmer den på nytt kan ingen CT-er opprettes fra den.',
      confirm: 'Gjør om til CT',
      moved: "'{name}' er en CT igjen — du finner den i CT-listen."
    }
  },
  oci: {
    registriesTitle: 'OCI-registryer',
    imagesTitle: 'OCI-bilder',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Generisk',
    providerImmutableHint: 'Provideren er uforanderlig etter opprettelsen — en annen provider er et nytt registry.',
    url: 'URL',
    urlHintPreset: 'Forhåndsutfylt av provideren — overstyr bare for mirrors.',
    urlHintRequired: 'Obligatorisk for generiske registryer: base-URL-en https://.',
    urlHintEcr: 'Obligatorisk: ECR-endpointene er per-konto/per-region — det finnes ingen preset.',
    credential: 'Legitimasjon',
    credentialNone: 'Anonym tilgang',
    credentialHint: 'En keystore-oppføring med brukernavn og passord; workerne løser den opp i bruksøyeblikket — aldri auth-filer per node.',
    nameHint: 'Host-aktig navn (docker.io, registry.intra); unikt per scope, uforanderlig',
    addRegistry: 'Legg til registry',
    addRegistryTitle: 'Legg til OCI-registry',
    verify: 'Verifiser',
    verifyState: 'Verifisering',
    verified: 'Verifisert',
    verifyFailed: 'Mislyktes',
    neverVerified: 'Aldri verifisert',
    registryInUseError: "'{name}' har fortsatt registrerte repositoryer — slett dem først.",
    repositories: 'Repositoryer',
    repositoriesHint: 'Å registrere observerer branchene (OCI-tagger) — ingenting lastes ned. Refreshen løser opp hver observerte branch og vedlikeholder refloggen.',
    noRepositories: 'Ingen repository registrert på dette registryet.',
    registerRepository: 'Registrer repository',
    repoPath: 'Sti',
    repoPathHint: "Repositoryets sti på registryet, f.eks. 'example' eller 'library/nginx'",
    branches: 'Brancher',
    branchesHint: 'Observerte brancher (OCI-tagger), kommaseparert — f.eks. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Løst opp NÅ: pullen laster ned digesten branchen peker på i dag.',
    refresh: 'Oppdater',
    deleteRepository: 'Slett repository',
    reflogCount: '{n} tidligere',
    noResolutions: 'Aldri oppdatert — ingen oppløsning observert.',
    refreshFailed: 'Siste oppdatering mislyktes ({when})',
    loadError: 'Kunne ikke laste repositoryene.',
    reference: 'Referanse',
    digest: 'Digest',
    digestHint: 'sha256:… — det eksakte bildet, uten branch (detached)',
    size: 'Størrelse',
    nodes: 'Noder',
    detached: 'detached',
    detachedHint: 'Lastet ned per digest, uten branch — drift-kontrollen gjelder ikke.',
    pulledAt: 'Lastet ned',
    pull: 'Pull',
    pullTitle: 'Pull bilde',
    pullHint: 'Pre-warming, aldri en forutsetning: en pull per branch løser opp NÅ og laster ned DEN digesten; en pull per digest er detached.',
    pullError: 'Pullen ble avvist',
    pullMode: 'Pull per',
    pullModeBranch: 'Branch (løs opp nå)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Den ærlige defaulten: som apt install, kjørt på nytt senere kan den gi et annet bilde.',
    pullModeDigestHint: 'Eksakt digest — reproduserbarhet og rollback; gir avkall på drift-kontrollen.',
    importFromRegistry: 'Importer fra registry',
    importFromCatalog: 'Importer fra katalog',
    importCatalogTitle: 'Importer OCI-bilde fra katalog',
    importCatalogHint: 'Den air-gappede veien: et klart oci-image-arkiv (tar/tar.gz — docker-archive eller oci-archive) materialiseres i bildestoren med referansen catalog/<katalog>/<fil>@<digest>; appene konsumerer det som hvilket som helst annet bilde. Arkivene lastes opp i katalogene — denne seksjonen importerer og intet mer.',
    importCatalogFile: 'Arkiv',
    importCatalogFileHint: 'De klare oci-image-filene i den valgte katalogen.',
    importCatalogNoFiles: 'Ingen klart oci-image-arkiv i denne katalogen — last opp et fra katalogdetaljen.',
    importCatalogError: 'Importen ble avvist',
    registry: 'Registry',
    repository: 'Repository',
    cacheMissing: 'Klusterets OCI-cache er ikke konfigurert — puller avvises til du setter en storage-pool.',
    setCache: 'Sett cache',
    setCacheTitle: 'Konfigurer OCI-cachen',
    setCacheHint: 'DEFAULT-poolen på klusternivå som huser blobene til de nedlastede bildene — en scope kan overstyre med sin egen pool (Scope-siden). Å bytte den er ikke hot og starter ingenting på nytt, og flytter ikke blobene: de dukker opp igjen lazy ved neste start/bruk.',
    cachePool: 'Storage-pool',
    changeCache: 'Bytt cache',
    changeCacheTitle: 'Bytt OCI-cachens pool',
    cacheCurrent: 'Klusterets OCI-cache (default): {name}',
    sectionOverview: 'Oversikt',
    sectionRepositories: 'Repositoryer',
    sectionExplore: 'Utforsk',
    exploreHint: 'Live remote-søk på registryet — Docker Hub fullt (beskrivelse, nedlastinger, stjerner), andre providere best-effort. Velg et resultat for å lese den fullstendige beskrivelsen og bla i de remote taggene; fra en tagg kan du legge referansen til et TVirt-repository.',
    exploreSearch: 'Søk',
    exploreUnsupported: 'Denne provideren støtter ikke søk.',
    exploreNoResult: 'Ingen matchende repository.',
    exploreNoTags: 'Ingen matchende tagg på dette repositoryet.',
    exploreOfficial: 'Offisiell',
    explorePulls: 'Nedlastinger',
    exploreStars: 'Stjerner',
    exploreUpdated: 'Oppdatert {when}',
    exploreLoadMore: 'Last flere',
    exploreSelectHint: 'Velg et resultat: fullstendig beskrivelse og remote tagger lastes her.',
    exploreNoDescription: 'Ingen beskrivelse tilgjengelig fra denne provideren.',
    exploreTagsTitle: 'Remote tagger',
    exploreTagFilter: 'Søk tagger',
    exploreAddToRepo: 'Legg til repository',
    exploreAdded: '{path}:{tag} spores nå — se seksjonen Repositoryer.',
    addBranch: 'Legg til branch',
    purgeRequiredTitle: "Slette '{name}' og bildene dens?",
    purgeRequiredBody: 'Ingen app bruker dette repositoryet, men det finnes fortsatt nedlastede bilder: sletting fjerner også postene deres, og de cachede blobene går til garbage collection.',
    purgeConfirm: 'Slett også bildene',
    providerSelectHint: 'Velg registry-typen: kortet forteller preset og bruk.',
    providerDesc: {
      dockerhub: 'Det offentlige Docker-registryet: URL forhåndsutfylt, fullt søk med beskrivelser og tellere.',
      ghcr: 'GitHub Container Registry: URL forhåndsutfylt; kontoer bruker et personal access token.',
      ecr: 'Amazon Elastic Container Registry: endepunkter per konto/region — URL-en må oppgis.',
      quay: 'Red Hat Quay-registryet: URL forhåndsutfylt.',
      generic: 'Self-hostet registry (Harbor, registry:2, …): https://-URL-en er obligatorisk.'
    },
    layerCount: 'Layers',
    verifiedAt: 'Siste verifisering',
    verifyOk: 'Utfall',
    verifyMessage: 'Verifiseringsmelding',

    // Modellen #348/R39: imaget ER digesten — innholdet — og registry, repository og branch er NAVNENE som når den.
    head: 'Head',
    heads: 'Heads per arkitektur',
    listDigest: 'Listens digest',
    neverResolved: 'Aldri løst opp',
    totalSize: 'Samlet størrelse',
    reflogTitle: 'Oppløsningshistorikk',
    usedBy: 'Brukt av',
    usageLockfile: 'lockfile',
    usageRunning: 'kjører',
    evictable: 'kan fjernes',
    evict: 'Fjern fra cachen',
    evictHeadTitle: 'Fjerne {digest}?',
    evictHeadBody: 'Det er den gjeldende oppløsningen til minst én samler: å fjerne den er legitimt — det er bare cache, den eksterne branchen serverer den fortsatt — men det må aldri skje ved et uhell. Bloben er ÉN: fjerningen tømmer alle samlerne som deler den.',
    evictConfirm: 'Fjern den likevel',

    arch: 'Arkitektur',
    names: 'Navn',
    noNames: 'ingen navn',
    views: 'Views',
    lastView: 'siste view',
    evictLastViewTitle: 'Fjerne den siste referansen til {digest}?',
    evictLastViewBody: 'Dette er det siste viewet på innholdet: fjerner du det, slutter imaget å finnes på TVirt, og bytene ({size}) frigjøres. Det er modellens docker image rm — ikke en sideeffekt, men selve operasjonen.',
    branchesTabHint: 'De observerte branchene i dette repositoryet: for hver av dem dagens heads — én per arkitektur — kronologien over oppdateringene og hvor mange av imagene den har navngitt som ligger i cachen. Oppdateringen er repositoryets «git fetch»: den løser opp alle branchene på én gang.',
    noBranches: 'Ingen branch observeres i dette repositoryet.',
    stopObserving: 'Slutt å observere branchen',
    pullBranch: 'Hent branchens head inn i cachen (refresh løser opp, denne laster ned)',
    pullDigest: 'Hent dette digestet inn i cachen',
    imageCount: 'Images',
    deleteBranchPurgeTitle: 'La imagene i {name} stå uten navn?',
    deleteBranchPurgeBody: 'Ingen app navngir denne branchen, men noen images nås bare gjennom den: sletter du den, blir de liggende i cachen uten navn, listet blant repositoryets images og mulige å rydde for hånd.',
    deleteBranchPurgeConfirm: 'Slett og la imagene stå uten navn',
    imagesTabHint: 'Imagene i dette repositoryet — innholdet, altså digestene — synlige også uten å velge en branch. Et image er unikt per klynge: navnene som når det kan være flere.',
    noImages: 'Ingen image fra dette repositoryet er materialisert i cachen.',
    deleteRepositoryTitle: 'Slette {name}?',
    deleteRepositoryBody: 'Repositoryet og branchene forsvinner, med kronologien sin. Imagene blir i cachen: de mister bare dette navnet. Et repository som en app navngir, kan ikke slettes.',
    provenanceCatalog: 'katalog',
    refreshedAt: 'Oppdatert',
    neverRefreshed: 'Aldri oppdatert',
    sectionBranches: 'Branches',
    sectionImages: 'Images',
    repositoriesGovernedElsewhere: 'Her ses repositoryene bare på: å registrere dem, oppdatere dem, observere branchene og rydde imagene skjer i seksjonen OCI-images.',
    gotoImages: 'Gå til OCI-images'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pods',
    containers: 'Containere',
    instances: 'Instanser',
    instancesTooltip: '{running} kjører, {error} i feil',
    placement: 'Plassering',
    spread: 'spredning',
    ha: 'HA',
    templateRevision: 'revisjon',
    deleting: 'Slettes',
    empty: 'Ingen pods — opprett en app (én container) eller en pod fra CLI (create-pod).',
    openInstances: 'Åpne instansene',
    rollingRestart: 'Rullerende omstart',
    scale: 'Skaler',
    scaleTitle: 'Skaler {name}',
    scaleHint: 'Antall instanser (0–64): opp fyller det laveste ledige ordinalet, ned trekker det høyeste tilbake og beholder de persistente dataene.',
    scaleError: 'Skalering mislyktes',
    replicas: 'Replikaer',
    deleteRunningError: '{name} kjører — stopp den først.',
    deleteInstancesIntro: 'Alle {count} instansene fjernes.',
    stateRunning: 'Kjører',
    stateStopped: 'Stoppet',
    editor: {
      createTitle: 'Opprett Pod',
      create: 'Opprett Pod',
      editTitle: 'Rediger Pod',
      nameHint: 'DNS-1123, høyst 58 tegn — instansene heter <navn>-<indeks>; uforanderlig etter opprettelse.',
      restartPolicy: 'Omstartspolicy',
      restartPolicyHint_always: 'Noden starter enhver avsluttet container på nytt, med eksponentiell backoff (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Bare en container som avslutter med annet enn null startes på nytt; avslutning 0 hviler.',
      restartPolicyHint_never: 'En avsluttet container lar stå som den er — instansen ender som succeeded eller failed.',
      grace: 'Frist (s)',
      graceHint: 'SIGTERM → SIGKILL-grensen for et stopp.',
      hostname: 'Vertsnavn',
      hostnameHint: 'Tomt = instansens navn.',
      hostnameDefault: 'instansens navn',
      sharePid: 'Del PID-navnerom mellom containerne',
      containersIntro: 'Init-containere kjører til slutt, i rekkefølge, før containerne starter; containerne deler instansens nettverk (én IP, localhost seg imellom).',
      initContainers: 'Init-containere',
      initAdd: 'Legg til init-container',
      initHint: 'Hver må avslutte med 0; en feil setter instansen i feil, og noden prøver igjen med backoff.',
      containerAdd: 'Legg til container',
      atLeastOne: 'En Pod trenger minst én container.',
      duplicateNames: 'Containernavn må være unike i Podden (init-containere inkludert).',
      containerName: 'Containernavn',
      containerInvalid: 'Denne containeren er ufullstendig: navn (DNS-1123), image, monteringer på deklarerte volumer, numeriske grenser og probe.',
      command: 'Kommando',
      commandHint: 'Overstyrer imagets entrypoint — ett argument per linje, aldri en shell-streng.',
      args: 'Argumenter',
      argsHint: 'Ett per linje (imagets CMD hvis tomt).',
      mounts: 'Monteringer',
      mountAdd: 'Legg til montering',
      mountNoVolumes: 'Deklarer først et volum i fanen Lagring.',
      readOnly: 'skrivebeskyttet',
      resources: 'Grenser',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (f.eks. 1.5)',
      memory: 'Minne (MiB)',
      memoryHint: 'podman --memory',
      health: 'Liveness-probe',
      healthCmd: 'Probe-kommando',
      healthCmdHint: 'Kjørt i containeren av noden ved hvert overvåkingstikk — ett argument per linje; avslutning 0 = frisk.',
      healthTimeout: 'Tidsavbrudd (s)',
      healthRetries: 'Forsøk',
      healthRetriesHint: 'Påfølgende feil før noden starter containeren på nytt.',
      ips: 'Statiske adresser',
      ipsHint: 'Én per instans, i ordenstallsrekkefølge — skalering utover listen avvises.',
      instance: 'instans',
      volumesHint: 'Volumene er Poddens; monteringsstien er hver containers (fanen Containere).',
      spread: 'Spredning',
      spreadHint_preferred: 'Instanser på ulike noder når det er mulig.',
      spreadHint_required: 'Instanser på ulike noder, ellers avviser skaleringen.',
      spreadHint_none: 'Bare beslutningstakeren.',
      ha: 'Høy tilgjengelighet (opt-in)',
      haHint: 'Hver persistent del på delt lagring; hvis noden dør, gjenskaper HA-decideren instansene på et annet medlem (automatisk failover, som HA-VM-er).',
      yes: 'ja',
      no: 'nei'
    },
    detail: {
      container: 'Container',
      actions: 'Handlinger',
      ready: 'Klar',
      notReady: 'Ikke klar',
      restarts: 'Omstarter',
      lastRestartAt: 'Siste omstart:',
      backoffUntil: 'Nytt forsøk kl.',
      stateAbsent: 'fraværende',
      stateRunning: 'kjører',
      stateTerminated: 'avsluttet',
      stateWaiting: 'venter',
      init: 'init',
      noInstances: 'Ingen instanser (replikaer 0).',
      ha: 'HA',
      haHint: 'Automatisk failover: hvis noden dør, gjenskaper HA-decideren instansen på et annet medlem (hver persistent del på delt lagring).',
      authority: 'Authority (node)',
      homeless: 'uten authority',
      homelessHint: 'En gjenoppretting fra checkpoint utelater authority (#380): ingen node betjener den før du skalerer Podden (også til samme antall replikaer).',
      restartContainer: 'Start bare denne containeren på nytt (podden forblir oppe)',
      divergingHint: 'Denne instansens ønskede tilstand avviker fra Poddens standard (PD-P19).',
      revisionLag: 'revisjon {applied} anvendt av {current}',
      updatedInstances: '{updated}/{desired} instanser på denne revisjonen'
    }
  }
}
